module.exports = __webpack_public_path__ + "static/media/img_noble.4dcfd791.jpg";